<template>
    <div class="card-list-autoup">
        <div :class="{
            'list-autoup-web' : $detect == 'web',
            'list-autoup-mobile' : $detect == 'mobile'
        }">
            <div class="header p-3" v-if="$detect == 'web'">
                Danh sách tin rao vặt tự động up(Auto up)
            </div>
            <div class="p-3 body">
                <div class="auto-up d-flex justify-content-center mt-3">
                    <div class="input-group w-50 position-relative">
                        <input type="text" class="form-control input-id-rv"
                            v-model="id"
                            placeholder="Mã số Rao vặt (ID)"
                            @keyup.enter="goUp()">
                        <span class="input-text-auto position-absolute" role="button"
                            @click="goUp()">
                            <i class="icon ion-ios-search"></i>
                        </span>
                        <p class="mb-0 text-center text-note-input-auto position-absolute">
                            * Tìm kiếm Rao vặt muốn sử dụng tính năng Up tự động
                        </p>
                    </div>
                </div>
                <div class="table-list-autoup mt-5">
                    <table
                    :class="{
                            'table table-bordered' : $detect == 'web',
                            'table table-borderless' : $detect == 'mobile'}">
                        <thead :class="{
                            'thead-table' : $detect == 'web'
                        }">
                            <tr>
                            <th scope="col" class="text-center">Mã tin</th>
                            <th scope="col" class="text-center">Đã up</th>
                            <th scope="col" class="text-center" v-if="$detect == 'web'">Còn lại</th>
                            <th scope="col" class="text-center">Trạng Thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in data" :key="index">
                                <th class="text-center">
                                    <router-link :to="{
                                        name: 'raovat-auto-up-show',
                                        query: {
                                            id: item.data.id
                                        }
                                    }" class="text-decoration-none fw-400">{{item.data.id}}</router-link>
                                </th>
                                <td class="text-center">{{item.count[1] ? item.count[1].count : 0}}{{$detect == 'mobile' ? '/'+item.total : ''}}</td>
                                <td class="text-center" v-if="$detect == 'web'">{{item.count[0] ? item.count[0].count : 0}}</td>
                                <td :class="{
                                        'text-center fw-600': true,
                                        'text-success': item.count[0] && item.count[0] != 0,
                                        'text-danger': item.count[1] && item.count[1].count === item.total
                                    }">
                                    {{item.count[1] && item.count[1].count === item.total ? 'Đã hết hạn' : 'Còn hạn'}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <ldc-pagination
                        :current_page="current_page"
                        :next_page="next_page"
                        :last_page="last_page"
                        :callData="getData"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            current_page: 0,
            next_page: 0,
            last_page: 0,
            id: '',
        }
    },
    watch: {
        id(val, oldVal){
            if(!(val * 1 == val && val % 1 == 0)){
                this.id = oldVal;
            }
        }
    },
    created() {
        this.getData(1);
    },
    methods: {
        async getData(page) {
            await apiGet('/v2/profile/raovat/auto_up', {
                page: page,
            }).then(res => {
                let data = res.data;
                this.data = data.data;
                this.current_page = data.current_page;
                this.next_page = data.next_page;
                this.last_page = data.last_page;
            })
        },
        goUp(){
            this.$router.push({
                name: 'raovat-auto-up-show',
                query: {
                    id: this.id
                }
            })
        }
    }
}
</script>
<style lang="scss">
    .card-list-autoup {
        padding: 0 !important;
    }
    .card-list-autoup {
        .body {
            .input-id-rv {
                height: 35px;
                padding: 10px 35px 10px 10px;
                border-radius: 5px;
                border: 1px solid rgba(0,0,0,.2);
                color: rgb(91, 87, 119);
                font-size: 14px;
                &:focus {
                    border: 1px solid #007bff !important;
                    outline: none;
                    box-shadow: none !important;
                }
            }
            .input-text-auto {
                right: 10px;
                z-index: 20;
                i {
                    font-size: 22px;
                }
            }
            .btn-search {
                padding: 5px 20px !important;
                margin-top: -3px;
                height: 35px;
            }
            .text-note-input-auto {
                font-size: 12px;
                color: #999;
                margin-top: 2px;
                bottom: -18px;
                left: 3px;
            }
        }
    }
    .list-autoup-web {
        .header {
            color: #0c81f6;
            border-bottom: 1px solid #0c81f6;
        }
        .table-list-autoup {
            margin-left: 100px;
            margin-right: 100px;
            .thead-table {
                th {
                    background: #0c81f6;
                    color: #fff;
                }
            }
        }
    }
    .list-autoup-mobile {
        .input-id-rv {
            font-size: 14px !important;
            width: 100%;
        }
        .btn-search {
            font-size: 14px !important;
        }
        .body {
            padding: 0 !important;
        }
        .auto-up {
            text-align: unset !important;
            p {
                font-size: 14px !important;
            }
            .text-note-input-auto {
                font-size: 12px !important;
                position: unset !important;
                text-align: left !important;
            }
        }
        .table-list-autoup {
            margin-top: 16px !important;
        }
        .input-group {
            width: 100% !important;
        }
    }
</style>
